// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3ajua","label":"Completed_label__1jZzc"};